import { PageType } from '../gamecloud/interface';
import Utils from '../utils/utils';

const COPY_BUTTON_ID: string = 'copy-donationurl'
const DONATION_URL_ID: string = 'donationurl';

class Account {
    private copyDonationUrlButton: HTMLButtonElement = document.getElementById(COPY_BUTTON_ID) as HTMLButtonElement;
    private donationURL: HTMLInputElement = document.getElementById(DONATION_URL_ID) as HTMLInputElement;

    public constructor() {
        // listen to click event
        this.copyDonationUrlButton.addEventListener('click', () => Utils.copyToClipboard(this.donationURL));
    }
}
export function initAccount() : void {
    if(window.pageType === PageType.Customers) {
        new Account();
    }
}
